<template>
    <div>
        <template v-if="totalSteps">
            <div :key="jaw" style="margin-top: 0px; justify-content: space-between; display: flex; padding: 8px 16px; box-shadow: inset 0 8px 15px rgba(0,0,0,.03);" class="overview-title">
                <span class="overview--sub-title roboto f16 bold--text">{{ $t('plan_calculator.' + jaw) }}</span>
                <div style="flex-grow: 1" />
                <pm-price class="black--text roboto bold--text f16 pm-price" :currency="$store.state.currency" :value="$store.state.simplePlan[jaw + 'JawTotal']" />
            </div>
            <div class="pm-smart-treatment-overview-item white pa20" style="box-shadow: 0 8px 15px rgba(0,0,0,.03); border-top: 1px dotted #dfe0e2!important;">
                <div style="display: flex;">
                    <div style="width: 44px; text-align: center; justify-self: center; align-self: center;" class="pm-smart-treatment-overview-item--left">
                        <v-icon style="transition: all .3s; margin: 0 0 0 0;" class="black--text" :style="jaw==='upper' ? 'transform: rotate(0deg)' : 'transform: rotate(180deg)'">
                            circle_slice_half
                        </v-icon><br>
                        <span style="white-space: nowrap">
                        {{ Helper.getToothNotation(range[0]) }}<template v-if="range[0] !== range[1]">
                            - {{ Helper.getToothNotation(range[1]) }}
                        </template>
                        </span>
                    </div>
                    <div style="margin: 0 14px; width: 2px; background: #DBDCDE;" />
                    <div style="flex-grow: 1;" class="pm-smart-treatment-overview-item--right">
                        <div style="margin-top: 5px; margin-bottom: 6px;" class="roboto black--text bold--text f13">
                            {{ title }}
                        </div>
                        <div v-for="(option, key) in options" v-if="option!==null" style="padding: 4px 0 4px 0; display: flex; justify-content: center; align-items: center; border-top: 1px dotted #eee;">
                            <div class="f12" style="color: #7B8088; flex-grow: 1;">
                                <span v-if="['full_jaw_6_12', 'full_jaw_6_14', 'full_jaw_8_12', 'full_jaw_8_14'].includes(option.tpl)">
                                    {{ getOptionTitle(option) }}
                                </span>

                                <span v-else>{{ option.amount }} {{ $t('plan_calculator.state_' + key) }}: {{ getOptionTitle(option) }}</span>
                            </div>
                            <div>
                                <pm-price style="color: #7B8088;" class="roboto f12 black--text" :value="option.price" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<style>
    .f17 {
      font-size: 17px;
    }
    .pm-smart-treatment-overview-item {
        position: relative;
    }

@media (min-width: 700px) {
    .pm-smart-treatment-overview-item {
        font-size: 20px;
        padding: 20px 40px;
    }

    .overview-title {
        padding: 8px 30px !important;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .pm-smart-treatment-overview-item--left {
        width: 74px !important;
        margin-left: -24px;
    }

    .pm-smart-treatment-overview-item--right div,
    .pm-smart-treatment-overview-item--right span {
        font-size: 18px !important;
    }

    .pm-price {
        font-size: 24px;
        padding-top: 5px;
    }
}
</style>

<script>


export default {
    props: {
        jaw: {
            type: String,
            default: "upper",
        },
    },
    computed: {
        options() {
            return this.getMainItems();
        },
        totalSteps() {
            const tpl = this.$store.state.simplePlan[this.jaw + "Tpl"];
            if (typeof tpl !== "undefined" && tpl !== null) return true;

            let i = 0;
            Object.keys(this.options).forEach((pid)=>{
               if (this.options[String(pid)] === null) return;
               i++;
            });
            return i > 0;
        },
        extraTotal() {
            return this.getExtraTotal();
        },
        title() {
            const tpl = this.$store.state.simplePlan[this.jaw + "Tpl"];
            if (typeof tpl !== "undefined" && tpl !== null) {
                app.$store.state.simplePlan[this.jaw + "JawTitle"] = this.$t("plan_simple.template_"+tpl.title);
                return this.$t("plan_simple.template_"+tpl.title);
            }

            const titles = [];
            let ids = [];
            Object.keys(this.options).forEach((pid) => {
                if (this.options[String(pid)] === null) return;
                //titles.push(this.$t("plan_calculator.state_" + pid));
                ids.push(parseInt(pid));
            });

            if (ids.includes(26)) titles.unshift(this.$t('plan_calculator.state_26'));

            if (ids.includes(9) && ids.includes(15)) titles.push(this.$t('plan_calculator.state_9') + "/" + this.$t('plan_calculator.state_15'));
            else if (ids.includes(9)) titles.push(this.$t('plan_calculator.state_9'));
            else if (ids.includes(15)) titles.push(this.$t('plan_calculator.state_15'));

            if (ids.includes(11)) titles.push(this.$t('plan_calculator.state_11'));

            app.$store.state.simplePlan[this.jaw + "JawTitle"] = titles.join(" + ");

            return titles.join(" + ");
        },
        range() {
            let tIds = [];
            this.$store.state.simplePlan.steps.forEach((step) => {
                if (step.jaw !== this.jaw) return;
                tIds = tIds.concat(step.tooth_id.split(","));
            });
            tIds = tIds.filter((id) => {
                return parseInt(id) > 0;
            });
            tIds = Helper.sortToothNumbers(tIds);
            return [tIds[0], tIds[tIds.length-1]];
        },
    },
    methods: {
        getToothIds(option) {
            if (typeof option.tooth_id === "undefined") return "";
            return "(" + Helper.getToothRanges(option.tooth_id, true) + ")";
        },
        getOptionTitle(option) {
            if (typeof option.variation_index !== "undefined") {
                return this.$store.state.localSettings.protocols[option.tpl].variation_titles[parseInt(option.variation_index)][this.$store.state.language] || this.$t("settings.type_treatment");
            }
            return this.$store.state.dentalStates[String(option.state_id)].title[this.$store.state.language] || this.$t("settings.type_treatment");
        },
        getExtraTotal() {
            let total = 0;
            Object.keys(this.options).forEach((key) => {
                if (this.options[String(key)] === null) return;
                total += this.options[String(key)].price;
            });
            return this.$store.state.simplePlan[this.jaw + "JawTotal"] - total;
        },
        getMainItems() {
            const ids = [9, 10, 11, 15, 26];
            const options = {
                "9": null,
                "10": null,
                "11": null,
                "15": null,
                "26": null,
            };

            const found = [];
            this.$store.state.simplePlan.steps.forEach((step) => {
                if (['full_dentures'].includes(step.tpl) && step.jaw === this.jaw && step.state_pid === 300) {
                    ids.push(300);
                    options['300'] = null;
                }
                if (step.tooth_id === "0" || step.tooth_id === "") return false;
                if (step.jaw !== this.jaw) return;
                if (['full_jaw_6_12', 'full_jaw_6_14', 'full_jaw_8_12', 'full_jaw_8_14'].includes(step.tpl) && step.state_pid === 15) return;
                if (!ids.includes(parseInt(step.state_pid))) return;
                if (step.amount === 0) return;

                if (typeof options[String(step.state_pid)] === 'undefined' || options[String(step.state_pid)] === null) options[String(step.state_pid)] = {};
                let opt = options[String(step.state_pid)];

                if (typeof step.options === "undefined") this.addToOptions(opt, step); // options[String(step.state_pid)] = step;
                else {
                    step.options.forEach((option) => {
                        if (parseInt(option.selected) === 1) this.addToOptions(opt, option); // options[String(step.state_pid)] = option;
                    });
                }
            });
            return options;
        },

        addToOptions(opt, step) {
            opt.tpl = step.tpl;
            if (typeof opt.amount === 'undefined') opt.amount = 0;
            if (typeof opt.price === 'undefined') opt.price = 0;
            if (typeof opt.tooth_id === 'undefined') opt.tooth_id = [];
            opt.amount += parseInt(step.amount);
            opt.price += parseInt(step.price);
            if (typeof step.variation_index !== 'undefined') opt.variation_index = step.variation_index;
            if (typeof step.state_id !== 'undefined') opt.state_id = step.state_id;
            if (typeof step.tooth_id !== 'undefined') opt.tooth_id.push(...step.tooth_id.split(','));
        },
    },
};
</script>
